var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlkimaErfolgsgeschichteBwOnlineShopRaketeStartItem8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 139,
    viewBox: "0 0 460 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M343.406 9.29808C275.232 -2.11043 184.949 -2.11043 116.774 9.29808C28.8563 23.9955 -33.2517 59.7627 20.63 95.2216L20.3216 95.3244C107.211 152.675 353.072 152.675 439.962 95.3244L439.653 95.2216C493.432 59.6599 431.324 23.8927 343.406 9.29808ZM437.391 94.6049L422.892 90.6993C340.322 140.856 119.962 140.856 37.391 90.6993L22.8923 94.6049C-30.9895 59.5572 30.193 23.9955 117.494 9.40086C185.257 -1.90486 275.026 -1.90486 342.789 9.40086C429.987 23.9955 491.17 59.4544 437.391 94.6049Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 459.683,
    y1: 138.337,
    x2: 384.01,
    y2: -114.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlkimaErfolgsgeschichteBwOnlineShopRaketeStartItem8);
export default __webpack_public_path__ + "static/media/alkima-erfolgsgeschichte-bw-online-shop-rakete-start-item-8.d4981fea0ccb5603222edef1d6b22d48.svg";
export { ForwardRef as ReactComponent };